import { render, staticRenderFns } from "./indexsearch.html?vue&type=template&id=0b1884a3&scoped=true&"
import script from "./indexsearch.js?vue&type=script&lang=js&"
export * from "./indexsearch.js?vue&type=script&lang=js&"
import style0 from "./indexsearch.sass?vue&type=style&index=0&id=0b1884a3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1884a3",
  null
  
)

component.options.__file = "indexsearch.vue"
export default component.exports